export default __webpack_public_path__ + "static/media/appStore.3e46618e.svg";